import axios from "axios";

export const getCountries = callback => {
  var promise = axios({
    method: "get",
    url: "/api/trabajando_countries"
  });
  promise
    .then(response => {
      callback(response);
    })
    .catch(err => {
      callback(err.response);
    });
};
